import { CheckoutOrigin, CheckoutOriginRegions } from '../types/Internationalization';

export const getRegionFromCheckoutOrigin = (checkoutOrigin: CheckoutOrigin) => {
  return CheckoutOriginRegions[checkoutOrigin];
};
